<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.89111 5.22412C3.13519 4.98004 3.5318 4.98004 3.77588 5.22412L7.99951 9.44873L12.2251 5.22412C12.4691 4.98042 12.8649 4.98031 13.1089 5.22412C13.3529 5.4682 13.3529 5.86482 13.1089 6.10889L8.44189 10.7749C8.19783 11.019 7.80219 11.0189 7.55811 10.7749L2.89111 6.10889C2.64704 5.86481 2.64704 5.4682 2.89111 5.22412Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
